import * as t from "react";
import e from "react-helmet";

var n = function n(t) {
  return 0 === t.indexOf("//") ? "https:" + t : t;
},
    _o = function o() {
  return _o = Object.assign || function (t) {
    for (var e, n = 1, o = arguments.length; n < o; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }, _o.apply(this, arguments);
},
    r = {
  Meta: function Meta(o) {
    var r = o.description,
        i = void 0 === r ? "" : r,
        a = o.lang,
        c = void 0 === a ? "en" : a,
        p = o.title,
        l = o.path,
        s = void 0 === l ? "/" : l,
        m = o.slug,
        g = o.ogImageUrl,
        u = void 0 === g ? "" : g,
        h = o.twitterImageUrl,
        d = void 0 === h ? "" : h,
        f = o.twitterHandle,
        y = void 0 === f ? "" : f,
        v = o.baseUrl,
        w = void 0 === v ? "" : v,
        b = o.siteTitle,
        O = m && "/" !== m ? m : "",
        S = m && "/" !== m ? s : "",
        T = [{
      name: "description",
      content: i
    }, {
      property: "og:title",
      content: p
    }, {
      property: "og:description",
      content: i
    }, {
      property: "og:type",
      content: "website"
    }, {
      property: "og:url",
      content: "".concat(w).concat(S).concat(O)
    }, {
      property: "og:sitename",
      content: w
    }, {
      name: "twitter:card",
      content: "summary"
    }, {
      name: "twitter:creator",
      content: b
    }, {
      name: "twitter:image:alt",
      content: p
    }, {
      name: "twitter:title",
      content: p
    }, {
      name: "twitter:description",
      content: i
    }];
    return "string" == typeof u && "" !== u ? T.push({
      property: "og:image",
      content: n(u)
    }) : "" === u || console.log("No Open Graph Image set in WmkSeo.Meta"), "string" == typeof d && "" !== d ? T.push({
      name: "twitter:image",
      content: n(d)
    }) : "" === d || console.log("No Twitter Image set in WmkSeo.Meta"), "" !== y ? T.push({
      name: "twitter:site",
      content: y
    }) : "" === y || console.log("No Twitter Handle set in WmkSeo.Meta"), t.createElement(e, {
      htmlAttributes: {
        lang: c
      },
      link: [{
        rel: "canonical",
        href: "".concat(w).concat(S).concat(O)
      }],
      title: p,
      titleTemplate: "%s | ".concat(b),
      meta: T
    });
  },
  Schema: function Schema(n) {
    var r = n.graphs,
        i = n.baseUrl,
        a = function (t, e, n) {
      void 0 === e && (e = {});
      var r = {
        "@type": t,
        "@id": n + "/#" + t.toLowerCase()
      };
      return _o(_o({}, r), e);
    }("WebSite", {
      name: n.siteTitle,
      url: i,
      publisher: {
        "@id": i + "/#organization"
      }
    }, i);

    r.push(a);
    var c = {
      "@context": "https://schema.org",
      "@graph": []
    };
    return r.forEach(function (t) {
      return c["@graph"].push(t);
    }), t.createElement(e, null, t.createElement("script", {
      type: "application/ld+json"
    }, JSON.stringify(c)));
  }
};

export { r as WmkSeo };